//
//
//
//
//

export default {
 created(){
   this.$router.push({name:'homePage'})
 } 
}
